// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-wrapper {
  background: #96c4a0;
  color: #FDFFFC;
  transition: 0.3s;
}
.nav-wrapper:hover .h-brand {
  color: #393939 !important;
}

.nav-link {
  border-bottom: solid 2px transparent;
  transition: 0.3s;
  padding-bottom: 0px;
  font-size: 1rem;
  font-weight: 600;
  color: rgb(0, 0, 0) !important;
}
.nav-link.current {
  color: #393939 !important;
  border-color: #217ed5;
}
.nav-link:hover:not(.current) {
  border-color: #217ed5;
  color: #717171 !important;
}

.h-brand {
  transition: 0.3s;
  color: rgb(0, 0, 0) !important;
}

.contain {
  background-color: #96c4a0;
  margin-top: 5px;
  padding-bottom: 10px;
  border-radius: 10px;
  transition: 0.3s;
}
.contain:hover {
  border-color: rgba(33, 126, 213, 0.4);
  box-shadow: 0px 8px 16px 2px rgba(68, 68, 68, 0.24);
}

.divider {
  background-color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/TNavbar/TNavbar.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EAEE,mBCkCU;EDjCV,cCLM;EDSN,gBAAA;AANF;AAYI;EACE,yBAAA;AAVN;;AAeA;EACE,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAZF;AAcE;EACE,yBAAA;EACA,qBC9BQ;ADkBZ;AAeE;EACE,qBClCQ;EDmCR,yBAAA;AAbJ;;AAiBA;EACE,gBAAA;EACA,8BAAA;AAdF;;AAiBA;EACI,yBCRQ;EDSR,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAdJ;AAgBE;EACE,qCC1Cc;ED2Cd,mDAAA;AAdJ;;AAkBA;EACI,uBAAA;AAfJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n.nav-wrapper {\n  // border-radius: $nav-radius;\n  background: $nav-back;\n  color:$white;\n  // box-shadow: 0px 8px 16px 2px rgba(68,68,68,0.14);\n  \n  // border: solid 1px $nav-outline;\n  transition: 0.3s;\n\n  &:hover {\n    // border-color: $nav-outline-hvr;\n    // box-shadow: 0px 8px 16px 2px rgba(68,68,68,0.24);\n\n    .h-brand {\n      color: $text-main!important;\n    }\n  }\n}\n\n.nav-link {\n  border-bottom: solid 2px transparent;\n  transition: 0.3s;\n  padding-bottom: 0px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: $text-ghost!important;\n\n  &.current {\n    color: $text-main!important;\n    border-color: $palette-1;\n  }\n\n  &:hover:not(.current) {\n    border-color: $palette-1;\n    color: $text-light!important;\n  }\n}\n\n.h-brand {\n  transition: 0.3s;\n  color: $text-ghost!important;\n}\n\n.contain{\n    background-color: $nav-back;\n    margin-top: 5px;\n    padding-bottom: 10px;\n    border-radius: 10px;\n    transition: 0.3s;\n\n  &:hover {\n    border-color: $nav-outline-hvr;\n    box-shadow: 0px 8px 16px 2px rgba(68,68,68,0.24);\n  }\n}\n\n.divider{\n    background-color: black;\n}","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
